import React, { useRef } from "react";
import { Box, Button } from "@mui/material";
import TextareaAutosize from "@mui/material/TextareaAutosize";

const LeftAlignedTextAreaWithButton = ({ getText }) => {
  const textRef = useRef();

  function handleSubmit(e) {
    e.preventDefault();
    if (textRef.current) {
      // console.log("i is textRef", textRef.current.value);
      getText(textRef.current.value);
    }
  }

  function handleKeyDown(e) {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  }

  return (
    <div>
      <TextareaAutosize
        ref={textRef}
        className="w-100 text-xl"
        aria-label="textarea"
        placeholder="Enter or copy paste your essay or other type of writing"
        style={{
          flex: 1,
          minWidth: 0,
          minHeight: 100,
          marginRight: 2,
          fontSize: 20,
          borderRadius: 5
        }}
        onKeyDown={handleKeyDown} // Add the onKeyDown event handler
      />
      <Button
        onClick={handleSubmit}
        variant="contained"
        color="primary"
        size="large"
      >
        Submit
      </Button>
    </div>
  );
};

export default LeftAlignedTextAreaWithButton;
